export class Route {
  providerId: string;
  providerName: string;
  routeId: string;
  routeName: string;
  color: string;

  constructor(providerId: string, providerName: string, routeId: string, routeName: string, color: string) {
    this.providerId = providerId;
    this.providerName = providerName;
    this.routeId = routeId;
    this.routeName = routeName;
    this.color = color;
  }
}
